// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g9GvP{width:100%;display:flex;justify-content:center;align-items:flex-start;overflow:hidden;transition:min-height .3s ease-in-out}.K7RgL{position:fixed;left:0;width:100%;display:flex;justify-content:center;pointer-events:none}.K7RgL.UDlDT{bottom:64px}.K7RgL.t3oko{padding:16px;bottom:0}.K7RgL.huANK{margin-top:16px;position:relative;padding:0;bottom:0;pointer-events:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerSlot": `g9GvP`,
	"bannerWrapper": `K7RgL`,
	"desktop": `UDlDT`,
	"mobile": `t3oko`,
	"notFixed": `huANK`
};
export default ___CSS_LOADER_EXPORT___;
